let adminBase = window._env_.VUE_APP_ADMIN_HOST



export const getHomeTaskPackageTable = params => {
  return axios.post(`${adminBase}/batchtaskpackage/query`, params)
}
export const getHomeTaskPackageDetail = id => {
  return axios.get(`${adminBase}/batchtaskpackage/get_${id}`)
}
export const createHomeTaskPackage = params => {
  return axios.post(`${adminBase}/batchtaskpackage/create`, params)
}
export const updateHomeTaskPackage = params => {
  return axios.post(`${adminBase}/batchtaskpackage/edit_${params.id}`, params)
}
export const deleteHomeTaskPackage = id => {
  return axios.post(`${adminBase}/batchtaskpackage/delete_${id}`)
}

export const getHomeTaskPackageTypeOptions = params => {
  return axios.get(`${adminBase}/batchtaskpackage/options`)
}



// WEBPACK FOOTER //
// ./src/views/task-package-home/task-package-home.api.js